<template>
    <div class="loading-panel text-center mt-4">
        <b-spinner v-if="status == 0" class="loading-spinner" variant="dark"></b-spinner>
        <b-card style="width: 50%" class="mx-auto" v-if="status == -1">
            {{ errorMessage }}<br />
            <b-btn class="mt-2" variant="primary" @click="$emit('init')">Coba lagi</b-btn>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'loading-widget',
    props: {
        status: { type: Number, required: true },
        errorMessage: { type: String, required: false, default: "Gagal terhubung ke server." }
    }
}
</script>
